module.exports = __webpack_public_path__ + "d299b3c2b89c55312b552b954a09cdec.png";